// extracted by mini-css-extract-plugin
module.exports = {"button":"StudentRaiseButton_button__2P8-m"};